/**
 * Module definition houses accessibilty-based components.
 *
 * @module stack.common.ui.application
 */
angular.module('stack.common.ui.application', [
  'stack.common.ui.application.stackApplication',
  'stack.common.ui.application.resolvers.ConstantResolver'
]);
